const Section05 = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section
      className='section03 w-full bg-main-section03 bg-bottom bg-cover'
      ref={contentsRef}
    >
      <div className='max-w-[1080px] mx-auto pt-[120px] pb-[240px] relative'>
        <h3 className='text-[#6479E5] text-[14px] font-[600] mb-[12px] text-center'>
          그룹사
        </h3>
        <p className='max-w-[230px] mx-auto text-[16px] leading-[25.6px] font-[600] text-white text-center whitespace-pre-line break-keep'>
          한국영업경제인협회는 우리 모두의 지속 가능한 내일을 함께 만들어
          대한민국 경제 발전에 이바지합니다.
        </p>
        <div className='w-full mt-[55px]'>
          <ul className='w-full flex justify-center items-center'>
            <li className='p-[5.5vw] border-[0.5px] border-[#FFFFFF4D] rounded-full mr-[-5vw]'>
              <img
                src='/imgs/section03_item_img01.webp'
                alt=''
                className='w-[80px] h-[80px] object-contain'
              />
            </li>
            <li className='p-[5.5vw] border-[0.5px] border-[#FFFFFF4D] rounded-full'>
              <img
                src='/imgs/section03_item_img02.webp'
                alt=''
                className='w-[80px] h-[80px] object-contain'
              />
            </li>
            <li className='p-[5.5vw] border-[0.5px] border-[#FFFFFF4D] rounded-full ml-[-5vw]'>
              <img
                src='/imgs/section03_item_img03.webp'
                alt=''
                className='w-[80px] h-[80px] object-contain'
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Section05;
